//@ts-nocheck
import React from "react";
import { useRouteMatch } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import { ApplicationState } from '../../../reducers/Index';
import { numberWithCommas } from '../../Common/Helpers';
import { FilterEarlyCareerReport, loadEarlyCareerReportCounts, handleFilterSelection, clearFilterSelection, setFilterValues, clearAllData } from '../../../actions/EarlyCareerReportActions';
import { Heading1, Heading2, Heading3, IRISLightGreyDivider, ReportText, TextLink, TextSpan } from '../../Common/SharedStyledComponents';
import styled, { css } from "styled-components";
import { Form } from "react-bootstrap";
import "./EarlyCareerReportMenu.css";
import { EarlyCareerReportAction } from '../../../interface/EarlyCareerReportInterface';

interface Props {
    //loadEarlyCareerReportCounts?: any; //already declared in EarlyCareerReportAction
    UserState?: any;
    EarlyCareerReportState?: any;
}

class EarlyCareerReportFilterMenu extends React.Component<Props & EarlyCareerReportAction, State> {
    constructor(props) {
        super(props);
    }
    handleApply() {
        const filterSelection = this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection;

        const updated_ecr_award = [], updated_gender = [], updated_suborg=[], updated_funder=[];

        if (filterSelection.checked_1) updated_ecr_award.push('1');
        if (filterSelection.checked_0) updated_ecr_award.push('0');

        if (filterSelection.checked_M) updated_gender.push('M');
        if (filterSelection.checked_F) updated_gender.push('F');
        if (filterSelection.checked_U) updated_gender.push('U');

        if (filterSelection.checked_suborg1) updated_suborg.push('suborg1');
        if (filterSelection.checked_suborg2) updated_suborg.push('suborg2');
        if (filterSelection.checked_suborg3) updated_suborg.push('suborg3');
        if (filterSelection.checked_suborg4) updated_suborg.push('suborg4');
        if (filterSelection.checked_suborg5) updated_suborg.push('suborg5');

        if (filterSelection.checked_NIH) updated_funder.push('NIH');
        if (filterSelection.checked_NSF) updated_funder.push('NSF');
        if (filterSelection.checked_nonfed) updated_funder.push('nonfed');
        if (filterSelection.checked_otherfunder) updated_funder.push('otherfunder');

        this.props.setFilterValues("ecr_award", updated_ecr_award);
        this.props.setFilterValues("gender", updated_gender);
        this.props.setFilterValues("suborg", updated_suborg);
        this.props.setFilterValues("funder", updated_funder);

        this.props.setFilterValues("no_compare", filterSelection.checked_no_compare)
        this.props.setFilterValues("ecr_award_compare", filterSelection.checked_ecr_award_compare)
        this.props.setFilterValues("gender_compare", filterSelection.checked_gender_compare)
        
        this.props.clearAllData(
            this.props.FilterEarlyCareerReport,
            this.props.UserState.report_display_id,
            {
                ecr_award: updated_ecr_award,
                gender: updated_gender,
                suborg: updated_suborg,
                funder: updated_funder,
                no_compare: filterSelection.checked_no_compare,
                ecr_award_compare: filterSelection.checked_ecr_award_compare,
                gender_compare: filterSelection.checked_gender_compare
            },
            this.props.UserState.report_vintage_early_career
        )

        const theValues = this.props.EarlyCareerReportState.EarlyCareerReportFilterSavedValues;
        const selected = theValues.ecr_award.length > 0 || theValues.funder.length > 0 || theValues.gender.length > 0 || theValues.suborg.length > 0;

        if (!selected)
            this.props.handleFilterSelection("toggleMenu", false);
        else
            this.props.handleFilterSelection("toggleMenu", true);

    }

    handleClear(event) {
        var filterSelection = this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection;
        var filterValues = {
            checked_1: false,
            checked_0: false,

            checked_M: false,
            checked_F: false,
            checked_U: false,

            checked_suborg1: false,
            checked_suborg2: false,
            checked_suborg3: false,
            checked_suborg4: false,
            checked_suborg5: false,

            checked_NIH: false,
            checked_nonfed: false,
            checked_NSF: false,
            checked_otherfunder: false,

            checked_no_compare: filterSelection.checked_no_compare,
            checked_ecr_award_compare: filterSelection.checked_ecr_award_compare,
            checked_gender_compare: filterSelection.checked_gender_compare
        };

        this.props.clearFilterSelection(filterValues);
        this.props.loadEarlyCareerReportCounts(
            this.props.UserState.report_display_id,
            {
                ecr_award: [],
                gender: [],
                suborg: [],
                funder: [],
            },
            this.props.UserState.report_vintage_early_career);
        
        this.props.clearAllData(
            this.props.FilterEarlyCareerReport,
            this.props.UserState.report_display_id,
            {
                ecr_award: [],
                gender: [],
                suborg: [],
                funder: [],
            },
            this.props.UserState.report_vintage_early_career
        );

        this.props.setFilterValues("ecr_award", []);
        this.props.setFilterValues("gender", []);
        this.props.setFilterValues("suborg", []);
        this.props.setFilterValues("funder", []);
    }

    handleChange(key, event) {
        const filterSelection = this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection;

        let updated_ecr_award = [];
        let updated_gender = [];
        let updated_suborg = [];
        let updated_funder = [];

        if (filterSelection.checked_1) {
            updated_ecr_award.push('1');
        }
        if (filterSelection.checked_0) updated_ecr_award.push('0');

        if (filterSelection.checked_M) updated_gender.push('M');
        if (filterSelection.checked_F) updated_gender.push('F');
        if (filterSelection.checked_U) updated_gender.push('U');

        if (filterSelection.checked_suborg1) updated_suborg.push('suborg1');
        if (filterSelection.checked_suborg2) updated_suborg.push('suborg2');
        if (filterSelection.checked_suborg3) updated_suborg.push('suborg3');
        if (filterSelection.checked_suborg4) updated_suborg.push('suborg4');
        if (filterSelection.checked_suborg5) updated_suborg.push('suborg5');

        if (filterSelection.checked_NIH) updated_funder.push('NIH');
        if (filterSelection.checked_NSF) updated_funder.push('NSF');
        if (filterSelection.checked_nonfed) updated_funder.push('nonfed');
        if (filterSelection.checked_otherfunder) updated_funder.push('otherfunder');

        //filter more
        if (event.target.checked) {
            //filter on career award
            if (key == "1" || key == "0") {
                updated_ecr_award = updated_ecr_award.concat([key])
            }
            //filter on gender
            else if (key == 'M' || key == 'F' || key == 'U')
                updated_gender = updated_gender.concat([key])
            //filter on suborg
            else if (key == 'suborg1' || key == 'suborg2' || key == 'suborg3' || key == 'suborg4' || key == 'suborg5')
                updated_suborg = updated_suborg.concat([key])
            //filter on suborg
            else if (key == 'NIH' || key == 'nonfed' || key == 'NSF' || key == 'otherfunder')
                updated_funder = updated_funder.concat([key])

        }
        //filter less
        else {
            //filter on career award
            if (key == '1' || key == '0') {
                updated_ecr_award = updated_ecr_award.filter(function (i) {
                    return i !== key
                })
            }
            else if (key == 'M' || key == 'F' || key == 'U')
                updated_gender = updated_gender.filter(function (i) {
                    return i !== key
                })
            else if (key == 'suborg1' || key == 'suborg2' || key == 'suborg3' || key == 'suborg4' || key == 'suborg5')
                updated_suborg = updated_suborg.filter(function (i) {
                    return i !== key
                })
            else if (key == 'NIH' || key == 'nonfed' || key == 'NSF' || key == 'otherfunder')
                updated_funder = updated_funder.filter(function (i) {
                    return i !== key
                })
        }

        this.props.handleFilterSelection("checked_" + key, event.target.checked);

        this.props.loadEarlyCareerReportCounts(
            this.props.UserState.report_display_id,
            {
                ecr_award: updated_ecr_award,
                gender: updated_gender,
                suborg: updated_suborg,
                funder: updated_funder
            },
            this.props.UserState.report_vintage_early_career
        );

    }

    menuToggle() {
        if (this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection.toggleMenu) return true;
        if (this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection.toggleMenu == undefined ||
            !this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection.toggleMenu)
            return false;
        
        const theValues = this.props.EarlyCareerReportState.EarlyCareerReportFilterSavedValues;
        const selected = theValues.ecr_award.length > 0 || theValues.funder.length > 0 || theValues.gender.length > 0 || theValues.suborg.length > 0;
        return selected;
    }
    
    render() {
        const suborgs = this.props.EarlyCareerReportState.Suborgs;
        const counts = this.props.EarlyCareerReportState.EarlyCareerReportFilterCounts;
        const filterSelection = this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection;

        if (this.menuToggle()) {
            return (
                <div></div>
            )
        }
        else
        return (
            <Aside>
                <StickyContainer>
                    <FilterContainer className="filter-container">
                        <Heading3 bold style={{ paddingBottom: 0, borderBottom: 1 }}>Filters</Heading3>
                        <span style={{ color: "gray", float: "right", fontSize: "18px", cursor: "pointer" }} onClick={() => this.props.handleFilterSelection("toggleMenu", true)}><i className='glyphicon glyphicon-chevron-down'></i></span>
                        <CheckboxGroup style={{ columnCount:4, columnWidth: "200px" }}>
                            <div className="formCheckDiv">
                                <ReportText bold style={{ paddingTop: 0 }}>Early Career Award</ReportText>
                                <Form.Check
                                    checked={filterSelection && filterSelection.checked_1}
                                    label={`Yes (${(counts == undefined) ? 'loading...' : numberWithCommas(counts.yes_ecr_award)})`}
                                    onChange={this.handleChange.bind(this, '1')}
                                />
                                <Form.Check
                                    checked={filterSelection && filterSelection.checked_0}
                                    label={`No (${(counts == undefined) ? 'loading...' :  numberWithCommas(counts.no_ecr_award)})`}
                                    onChange={this.handleChange.bind(this, '0')}
                                />
                            </div>
                            <div className="formCheckDiv">
                                <ReportText bold>Gender</ReportText>
                                <Form.Check
                                    checked={filterSelection && filterSelection.checked_M}
                                    label={`Male (${(counts == undefined) ? 'loading...' :  numberWithCommas(counts.male_gender)})`}
                                    onChange={this.handleChange.bind(this, 'M')}
                                />
                                <Form.Check
                                    checked={filterSelection && filterSelection.checked_F}
                                    label={`Female (${(counts == undefined) ? 'loading...' :  numberWithCommas(counts.female_gender)})`}
                                    onChange={this.handleChange.bind(this, 'F')}
                                />
                                <Form.Check
                                    checked={filterSelection && filterSelection.checked_U}
                                    label={`Unknown (${(counts == undefined) ? 'loading...' :  numberWithCommas(counts.unknown_gender)})`}
                                    onChange={this.handleChange.bind(this, 'U')}
                                />
                            </div>
                            <div className="formCheckDiv">
                                <ReportText bold>Academic Unit</ReportText>
                                {
                                suborgs && counts &&
                                    suborgs.map((option) => {
                                        const ze_count = counts['suborg' + option.suborg_rank];
                                        return (<Form.Check
                                            checked={filterSelection && filterSelection["checked_suborg"+option.suborg_rank]}
                                            label={`${option.ranked_suborg} (${numberWithCommas(ze_count)})`}
                                            onChange={this.handleChange.bind(this, 'suborg' + option.suborg_rank)}
                                        />)
                                    })
                                }
                                {!counts &&
                                    <i className="fa fa-spinner"></i>
                                }
                            </div>                            
                            <div className="formCheckDiv">
                                <ReportText bold>Primary Funding Source</ReportText>
                                <Form.Check 
                                    checked={filterSelection && filterSelection.checked_NIH}
                                    label={`NIH (${(counts == undefined) ? 'loading...' :  numberWithCommas(counts.nih_funder)})`}
                                    onChange={this.handleChange.bind(this, 'NIH')}
                                />
                                <Form.Check 
                                    checked={filterSelection && filterSelection.checked_NSF}
                                    label={`NSF (${(counts == undefined) ? 'loading...' :  numberWithCommas(counts.nsf_funder)})`}
                                    onChange={this.handleChange.bind(this, 'NSF')}
                                />
                                <Form.Check
                                    checked={filterSelection && filterSelection.checked_nonfed}
                                    label={`Non-Federal (${(counts == undefined) ? 'loading...' :  numberWithCommas(counts.nonfed_funder)})`}
                                    onChange={this.handleChange.bind(this, 'nonfed')}

                                />
                                <Form.Check 
                                    checked={filterSelection && filterSelection.checked_otherfunder}
                                    label={`Other (${(counts == undefined) ? 'loading...' :  numberWithCommas(counts.other_funder)})`}
                                    onChange={this.handleChange.bind(this, 'otherfunder')}
                                />
                            </div>
                        </CheckboxGroup>
                        <div style={{ paddingTop: "10px" }}>
                            <button className="filter" onClick={this.handleApply.bind(this)}>Apply</button>
                            <button className="cancel" onClick={this.handleClear.bind(this)}>Clear</button>
                        </div>
                    </FilterContainer>
                </StickyContainer>
            </Aside>);
    }
}


const Aside = styled.div`
`;

const StickyContainer = styled.div`
    position: sticky;
    top: 120px;
    background: white;
    padding-inline: 5px;
    padding-bottom: 25px;
    border-radius: 0px;
    border: solid 1px #D3D3D3;
    margin-bottom: 10px;
`;

const ReportNavContainer = styled.div`
    padding: 10px;
`;

const ReportNavListItem = styled.p`
    font-size: 14px;
    text-align: left;
    margin-block: 5px;
    ${props => props.indented && css`
        margin-left: 15px;
    `}
`;

const FilterContainer = styled.div`
    padding-inline: 10px;
    font-size: 12px;
`;

const CheckboxGroup = styled.div`
    max-height: 120px;
`;


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadEarlyCareerReportCounts: loadEarlyCareerReportCounts,
            handleFilterSelection: handleFilterSelection,
            clearFilterSelection: clearFilterSelection,
            setFilterValues: setFilterValues,
            FilterEarlyCareerReport: FilterEarlyCareerReport,
            clearAllData: clearAllData
        }, dispatch
    );
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    EarlyCareerReportState: state.earlyCareerReportProperties
});

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(EarlyCareerReportFilterMenu, "Early Career Report Menu", "landing page"));



